// i18next-extract-mark-ns-start Footer

/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
// cSpell:ignore itemreviewed

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from '../../../services/link';

import withAppContext from '../../../withAppContext';
import withOrderContext from '../../../withOrderContext';
import withCustomerContext from '../../../withCustomerContext';
import dropdownArrow from '../../../assets/arrow-dropdown-list.white.svg';
import routesMap from '../../../Routes';
import {
  fontWeight, margins, tabletThresholdPixels,
  ContainerFooter, Content, LineV,
}
  from '../v2/styledComponents';
import { fontSizes, colors } from './styledComponents';
import LeftBlock from './FooterLeftBlock';
import FooterMobileAndSocial from './FooterMobileAndSocial';
import logoTilli from '../../../assets/logos/tilli.white.svg';
import logoJoinTheCycle from '../../../assets/footer/joinTheCycle.logo.footer.png';
import contactInfos from '../../../config/contactInfos';
import { ratingData } from './ratingData';
import { isMultilingual, shouldShowIfEnglish } from '../../../../languages';
import { mobileThresholdPixels } from '../v4/styledComponents';
import { getFooterContent, getSEAMultilingualFooterContent } from './FooterData';

const StyledContainerFooter = styled(ContainerFooter)`
  display: flex;
  align-items: center;
  height: 649px;
  margin: 0;
  @media (max-width: ${tabletThresholdPixels}) {
    padding-bottom: 0px;
    height: 100%;
    justify-content: center;
  }
`;

const StyledContent = styled(Content)`
  background-color: ${colors.black};
  margin: 0 auto;
  width: unset;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 0 80px;
    width: 100%;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: 0 0 80px;
    width: auto;
  }
`;

const SubContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    align-items: center;
  }
`;

const TextMainContainer = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: center;
  flex-wrap: wrap;
  gap: 30px;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 10px 0px;
    justify-content: center;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin-top: 10px;
    justify-content: center;
  }
`;

const BlockSuperContainer = styled.div`
  text-align: initial;
`;

const BlockContainer = styled.div`
  font-size: ${fontSizes.s};
  color: ${colors.beige100};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: initial;
  @media (max-width: ${tabletThresholdPixels}) {
    padding: 0px 13px;
    margin: 0px;
    align-items: center;
  }
`;

const TextContainer = styled.div`
  color: ${colors.beige100};
  font-family: Roboto;
  font-size: ${fontSizes.s};
  font-weight: ${fontWeight.light};
  line-height: 24px;
  ${(props) => props.pointer && 'cursor: pointer'};
  text-align: left;
  @media (max-width: ${tabletThresholdPixels}) {
    font-weight: ${fontWeight.regular};
    ${(props) => props.link && `padding-bottom: ${margins.s};`}
    ${(props) => props.centered && 'text-align: center'}
  }
`;

const BlockTitle = styled.div`
  color: ${colors.beige100};
  font-size: 16px;
  font-weight: 700;
  line-height: 30px;
  text-transform: uppercase;
  margin-bottom: 6px;
  text-align: start;

  @media (max-width: ${tabletThresholdPixels}) {
    text-align: center;
  }
`;

const A = styled.a`
  color: ${colors.black};
  text-decoration: none;
`;

const LinkText = styled.div`
  color: ${colors.beige100};
  font-family: Roboto;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  cursor: ${(props) => props.noCursor ? 'auto' : 'pointer'};
  @media (max-width: ${tabletThresholdPixels}) {
    font-weight: ${fontWeight.regular};
    font-size: 12px;
    line-height: 20px;
    ${(props) => props.link && `padding-top: ${margins.s};`}
  }
`;

const LinkTextInline = styled.span`
  color: ${colors.beige100};
  font-size: 16px;
  cursor: ${(props) => props.noCursor ? 'auto' : 'pointer'};
  text-align: left;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 12px;
    ${(props) => props.link && `padding-top: ${margins.s};`}
  }
`;

const MenusContainer = styled.div`
  border-color: ${colors.beige100};
  border-style: solid;
  border-width: 1px 0px;
  margin: ${margins.m} auto 0px;
  @media (max-width: ${tabletThresholdPixels}) {
    padding: 15px 0px;
    margin: 0px 13px 30px 13px;
    display: flex;
    flex-direction: column;
    gap: 17px;
  }
`;

const MenuContainer = styled.div`
  margin: ${margins.m} auto;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0px;
  }
`;

const MenuTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: ${tabletThresholdPixels}) {
    padding-bottom: 15px;
  }
`;

const MenuTitle = styled.h3`
  color: ${colors.beige100};
  font-size: 18px;
  font-weight: 700;
  line-height: 30px;
  text-transform: uppercase;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 15px;
    line-height: 24px;
    margin: 0;
  }
`;

const Img = styled.img`
  padding-bottom: 1px;
  margin-left: 4px;
  width: 10px;
  ${(props) => props.rotate && 'transform: rotate(180deg)'};
`;

const LogoImg = styled.img`
  width: 200px;
  margin-bottom: 100px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: calc(100% - 26px);
    margin: 40px auto;
  }
`;

const LogoJTC = styled.img`
  display: flex;
  margin-bottom: 20px;
  width: 120px;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 auto 40px;
  }
`;

const StyledLineV = styled(LineV)`
  align-self: stretch;
  height: unset;
  max-height: 385px;
  width: 2px;
`;

const LegalContainer = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  @media (max-width: ${tabletThresholdPixels}) {
    text-align: center;
    margin-top: 12px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    text-align: center;
    display: block;
    margin-top: 12px;
  }
`;

const ContactText = styled.p`
  font-family: Roboto;
  font-size: 18px;
  color: ${colors.beige100};
  text-align: left;
  margin: 72px 0px;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 25px 0px;
    padding: 0px 24px;
    font-size: 14px;
    text-align: center;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    padding: 0px 12px;
    margin: 0 0 50px;
  }
`;

const StyledDiv = styled.div`
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    max-width: 1100px;
    margin-left: 0px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    width: 100%;
    max-width: 326px;
    margin-left: 0px;
  }
`;

const StyledBottomDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 60px;
  @media (max-width: ${tabletThresholdPixels}) {
    justify-content: center;
    padding: 0px 24px;
    line-height: 20px;
    font-size: 13px;
    margin: 0 0 50px;
  }

`;

const ContactLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-weight: 700;
`;

const CURRENT_YEAR = new Date().getFullYear();

const renderContact = (t, beTillistePage) => (
  <ContactText>
    <span>
      {t('Vous n‘avez toujours pas trouvé de réponse à votre question ? Contactez-nous à ')}
    </span>
    <br />
    {beTillistePage ? (
      <ContactLink href={`mailto:${contactInfos.tillisteMail}`}>{contactInfos.tillisteMail}</ContactLink>
    ) : (
      <ContactLink href={`mailto:${contactInfos.mail}`}>{contactInfos.mail}</ContactLink>
    )}
    {t(' ou au ')}
    <ContactLink href={`tel:${contactInfos.phoneNumberInter}`}>{contactInfos.phoneNumber}</ContactLink>
  </ContactText>
);

export const renderRating = (t) => (
  <LinkTextInline noCursor>
    <LinkTextInline
      noCursor
      itemScope
      itemType="http://schema.org/LocalBusiness"
    >
      <LinkTextInline
        noCursor
        itemScope
        itemType="http://data-vocabulary.org/Review-aggregate"
      >
        <LinkTextInline itemProp="itemreviewed" noCursor>{isMultilingual ? 'Tilli.com' : 'Tilli.fr'}</LinkTextInline>
        {t(' a reçu la note de ')}
        <LinkTextInline
          noCursor
          itemProp="rating"
          itemScope
          itemType="http://data-vocabulary.org/rating"
        >
          <LinkTextInline itemProp="average" noCursor>{ratingData.scoring}</LinkTextInline>
          {' / '}
          <LinkTextInline itemProp="best" noCursor>10</LinkTextInline>
        </LinkTextInline>
        {t(' sur ')}
        <LinkTextInline itemProp="votes" noCursor>{ratingData.numberOfReviews}</LinkTextInline>
        {t(' avis.')}
      </LinkTextInline>
    </LinkTextInline>
  </LinkTextInline>
);

const renderLegal1 = (t) => (
  <LegalContainer>
    <LinkTextInline noCursor>{`@${CURRENT_YEAR} Tilli`}</LinkTextInline>
    <LinkTextInline noCursor>{t('Tous droits réservés')}</LinkTextInline>
  </LegalContainer>
);

const renderLegal2 = (t) => (
  <LegalContainer>
    <Link
      style={{ textDecoration: 'none', color: 'inherit' }}
      to={routesMap.LegalTerms.url}
    >
      <LinkTextInline>{t('CGV/CGU & Mentions Légales')}</LinkTextInline>
    </Link>
    <Link
      style={{ textDecoration: 'none', color: 'inherit' }}
      to={routesMap.Insurance.url}
    >
      <LinkTextInline>{t('Notre assurance MMA')}</LinkTextInline>
    </Link>
    <A
      target="_blank"
      rel="noreferrer noopener"
      // cSpell:disable-next-line
      href={isMultilingual ? '/EN_Tilli_Privacy_Policy_20230719.pdf' : '/Tilli_Politique_de_confidentialite_20230719.pdf'}
    >
      <LinkTextInline>{t('Politique de confidentialité')}</LinkTextInline>
    </A>
  </LegalContainer>
);

const renderLegalMobile = (t) => (
  <LegalContainer>
    <Link
      style={{ textDecoration: 'none', color: 'inherit' }}
      to={routesMap.Insurance.url}
    >
      <LinkTextInline>{t('Notre assurance MMA')}</LinkTextInline>
    </Link>
    <LinkTextInline>{' | '}</LinkTextInline>
    <Link
      style={{ textDecoration: 'none', color: 'inherit' }}
      to={routesMap.LegalTerms.url}
    >
      <LinkTextInline>{t('CGV/CGU')}</LinkTextInline>
    </Link>
    <LinkTextInline>{' | Tous droits réservés'}</LinkTextInline>
  </LegalContainer>
);

function isOpen(openedIndex, index) {
  if (typeof window === 'undefined') return true; // open all links for the pre-render (SEO optimization)
  return openedIndex === index;
}

class Footer1 extends React.Component {
  constructor() {
    super();
    this.state = { openedIndex: -1 };
  }

  renderMyAccount = () => {
    const { t } = this.props;
    const { customerContext: { customer } } = this.props;
    if (!customer) return null;
    return (
      <Link style={{ textDecoration: 'none', color: 'inherit' }} to={routesMap.MyAccount.url}>
        <BlockTitle>{t('Mon compte')}</BlockTitle>
      </Link>
    );
  };

  renderDesktop(footerContent) { // eslint-disable-line class-methods-use-this
    const { t } = this.props;
    return (
      <>
        {footerContent.map((content) => (
          <BlockSuperContainer key={`${content.index}_desktop`}>
            <BlockContainer>
              <BlockTitle>{content.title}</BlockTitle>
              {content.links.map((link) => (
                <div key={`${link.text}_desktop`}>
                  {!!link.url && (
                    <Link
                      key={`${link.url}_desktop`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      to={link.url}
                      onClick={() => typeof link.onClick === 'function' && link.onClick()}
                    >
                      <LinkText>{link.text}</LinkText>
                      {link.emptyLineNext && <br />}
                    </Link>
                  )}
                  {!!link.urlNewTab && (
                    <a
                      key={`${link.urlNewTab}_desktop`}
                      target="_blank"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      rel="noreferrer noopener"
                      href={link.urlNewTab}
                    >
                      <LinkText>{link.text}</LinkText>
                      {link.emptyLineNext && <br />}
                    </a>
                  )}
                </div>
              ))}
              {content.contactInfos
                && (
                  <TextContainer>
                    <br />
                    <br />
                    {contactInfos.mail}
                    <br />
                    {contactInfos.phoneNumber}
                  </TextContainer>
                )}
              {content.showRating && renderRating(t)}
            </BlockContainer>
          </BlockSuperContainer>
        ))}
      </>
    );
  }

  renderMobile(footerContent) {
    const { t, beTillistePage } = this.props;
    const { openedIndex } = this.state;
    return (
      <div>
        <ContactText>
          <span>
            {t('Vous n‘avez toujours pas trouvé de réponse à votre question ? Contactez-nous à ')}
          </span>
          <br />
          {beTillistePage ? (
            <ContactLink href={`mailto:${contactInfos.tillisteMail}`}>{contactInfos.tillisteMail}</ContactLink>
          ) : (
            <ContactLink href={`mailto:${contactInfos.mail}`}>{contactInfos.mail}</ContactLink>
          )}
          <br />
          {t(' ou au ')}
          <ContactLink href={`tel:${contactInfos.phoneNumberInter}`}>{contactInfos.phoneNumber}</ContactLink>
        </ContactText>
        <MenusContainer>
          {footerContent.map((content, index) => (
            <MenuContainer key={`${content.title}_mobile`}>
              <MenuTitleContainer onClick={() => this.setState({ openedIndex: openedIndex === index ? -1 : index })}>
                <MenuTitle>{content.title}</MenuTitle>
                <Img
                  alt="Flèche menu déroulant"
                  src={dropdownArrow}
                  rotate={isOpen(openedIndex, index) ? 'true' : undefined}
                />
              </MenuTitleContainer>
              {isOpen(openedIndex, index) && content.links.map((link) => (
                <div key={`${link.text}_mobile`}>
                  {!!link.url && (
                    <Link
                      key={`${link.url}_mobile`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      to={link.url}
                    >
                      <TextContainer link>{link.text}</TextContainer>
                    </Link>
                  )}
                  {!!link.urlNewTab && (
                    <a
                      key={`${link.urlNewTab}_mobile`}
                      target="_blank"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      rel="noreferrer noopener"
                      href={link.urlNewTab}
                    >
                      <TextContainer link>{link.text}</TextContainer>
                    </a>
                  )}
                </div>
              ))}
            </MenuContainer>
          ))}
        </MenusContainer>
        <FooterMobileAndSocial />
        {renderRating(t)}
        {renderLegalMobile(t)}
      </div>
    );
  }

  render() {
    const { t, beTillistePage, isSEAMultilingual } = this.props;
    const { context: { isMobile } } = this.props;
    const { orderContext: { getOrderRouteAndEvent }, isLeatherGoods } = this.props;
    const { orderRoute, restart } = getOrderRouteAndEvent();
    const footerContent = !isSEAMultilingual ? getFooterContent(t, orderRoute, restart, isLeatherGoods).map((content) => ({
      ...content,
      links: content.links.filter((link) => shouldShowIfEnglish(link.url)),
    })).filter((content) => content.links.length > 0) : getSEAMultilingualFooterContent(t, orderRoute, restart);
    return (
      <StyledContainerFooter>
        <StyledContent>
          <SubContainer>
            {!isMobile && <LeftBlock />}
            {!isMobile
              && <StyledLineV margin="0 40px" color={colors.beige100} />}
            <StyledDiv>
              {isMobile && <LogoImg src={logoTilli} alt="logo Tilli" />}
              <LogoJTC src={logoJoinTheCycle} alt="logo Join The Cycle" />
              <TextMainContainer>
                {!isMobile ? this.renderDesktop(footerContent) : this.renderMobile(footerContent)}
              </TextMainContainer>
              {!isMobile && this.renderMyAccount()}
              {!isMobile && renderContact(t, beTillistePage)}
              <StyledBottomDiv>
                {!isMobile && renderLegal1(t)}
                {!isMobile && renderLegal2(t)}
                {!isMobile && renderRating(t)}
              </StyledBottomDiv>
            </StyledDiv>
          </SubContainer>
        </StyledContent>
      </StyledContainerFooter>
    );
  }
}

Footer1.propTypes = {
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
  customerContext: PropTypes.shape({
    customer: PropTypes.shape({}),
  }).isRequired,
  orderContext: PropTypes.shape({
    getOrderRouteAndEvent: PropTypes.func,
  }).isRequired,
  isLeatherGoods: PropTypes.bool,
  t: PropTypes.func.isRequired,
  beTillistePage: PropTypes.bool,
  isSEAMultilingual: PropTypes.bool,
};

Footer1.defaultProps = {
  isLeatherGoods: false,
  beTillistePage: false,
  isSEAMultilingual: false,
};

export default withTranslation()(withAppContext(withCustomerContext(withOrderContext(Footer1))));
